module.exports = __webpack_public_path__ + "img/no-dashboard-gray.a8fc6cd8.svg";